/* istanbul ignore file -- MSP/LIS quiz is no longer in production */
import React, { useState } from "react";
import { MspLisQuiz } from "./MspLisQuiz";
import { MspLisQuizEarlyExitModal } from "./MspLisQuizEarlyExitModal";

export type MspLisQuizContainerProps = {
  setShowMspLisQuiz: (taking: boolean) => void;
};

export function MspLisQuizContainer({
  setShowMspLisQuiz,
}: MspLisQuizContainerProps): React.JSX.Element {
  const [showEarlyExitModal, setShowEarlyExitModal] = useState<boolean>(false);
  const [isQuizComplete, setIsQuizComplete] = useState<boolean>(false);

  // TODO - Extract the quiz results submission to this component.

  return (
    <React.Fragment>
      {
        showEarlyExitModal && (
          <React.Fragment>
            <MspLisQuizEarlyExitModal
              onCancelExitClicked={() => setShowEarlyExitModal(false)}
              onConfirmExitClicked={() => setShowMspLisQuiz(false)}
            />
          </React.Fragment>
        )
      }

      <MspLisQuiz
        onExitEarly={() => {
          if (isQuizComplete) {
            setShowMspLisQuiz(false);
          } else {
            setShowEarlyExitModal(true);
          }
        }}
        onQuizComplete={() => setIsQuizComplete(true)}
        onQuizReset={() => setIsQuizComplete(false)}
      />
    </React.Fragment>
  );
}

